import React, { Component } from "react";
import Select from "react-select";
import { connect } from "react-redux";
import "./CountryDropDown.scss";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import { ReactComponent as GlobeIcon } from "../../../../../../assets/svg/globe-icon.svg";
import { ReactComponent as CuraCao } from "../../../../../../assets/svg/curacao.svg";
import { ReactComponent as BonaireIcon } from "../../../../../../assets/svg/bonaire.svg";
import { ReactComponent as Guernsey } from "../../../../../../assets/svg/guernsey.svg";
import { ReactComponent as Isleofman } from "../../../../../../assets/svg/Isleofman.svg";
import { ReactComponent as Bostonian } from "../../../../../../assets/svg/bostonian.svg";
import { ReactComponent as UnknownFlag } from "../../../../../../assets/svg/unknown-flag.svg";
import { ReactComponent as SintMarteen } from "../../../../../../assets/svg/sint-maarten.svg";
import { ReactComponent as SouthSudan } from "../../../../../../assets/svg/South-Sudan.svg";
import { ReactComponent as Jersey } from "../../../../../../assets/svg/jersey.svg";
import { ReactComponent as SaintBarthelemy } from "../../../../../../assets/svg/Saint-Barthelemy.svg";
class CountryDropDown extends Component {
    constructor(props) {
        super(props);
    }
    customFlagRenderer = (_flagMiss, name) => {
        if (name === "Curacao") {
            return (
                <span>
                    <CuraCao className="custom-icon" />
                </span>
            );
        } else if (name === "Bonaire, Sint Eustatius and Saba") {
            return (
                <span>
                    <BonaireIcon className="custom-icon" />
                </span>
            );
        } else if (name === "Guernsey") {
            return (
                <span>
                    <Guernsey className="custom-icon" />
                </span>
            );
        } else if (name === "Jersey") {
            return (
                <span>
                    <Jersey className="custom-icon" />
                </span>
            );
        } else if (name === "Isle of Man") {
            return (
                <span>
                    <Isleofman className="custom-icon" />
                </span>
            );
        } else if (name === "Millennium Bostonian") {
            return (
                <span>
                    <Bostonian className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Martin") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Sint Maarten") {
            return (
                <span>
                    <SintMarteen className="custom-icon" />
                </span>
            );
        } else if (name === "Saint Barthelemy") {
            return (
                <span>
                    <SaintBarthelemy className="custom-icon" />
                </span>
            );
        } else if (name == "Worldwide") {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        } else if (name === "South Sudan") {
            return (
                <span>
                    <SouthSudan className="custom-icon" />
                </span>
            );
        } else if (name == "Unknown") {
            return (
                <span>
                    <UnknownFlag className="custom-icon" />
                </span>
            );
        } else {
            return (
                <span>
                    <GlobeIcon className="custom-icon" />
                </span>
            );
        }
    };
    flagRenderer = (item) => <Flag name={item} />;
    formatOptionLabel = ({ value, label, flag, flag_miss }) => (
        <div style={{ display: "flex" }}>
            <div
                style={{
                    marginLeft: "0px",
                    color: "#ccc",
                }}
                className={`${flag_miss === "yes" ? "align__up-icon" : ""}`}>
                {flag_miss === "yes" ? this.customFlagRenderer(flag_miss, label) : this.flagRenderer(flag)}
            </div>
            <div>{label}</div>
        </div>
    );

    customStyle = {
        control: (base) => ({ ...base, border: 0, boxShadow: "none", background: "#FFF", color: "#1F2E3D" }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            return { ...styles, backgroundColor: isSelected ? "#F7F7F7" : null, color: "#1F2E3D" };
        },
        dropdownIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
        clearIndicator: (base) => ({
            ...base,
            color: "#697384",
        }),
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#8093b2",
            };
        },
    };
    getCountryList = () => {
        let countries = this.props.allLocations || [];
        let countryOptions = countries.filter((ele) => {
            return (
                ele.name !== "Abu Dhabi" &&
                ele.name !== "Antarctica" &&
                ele.name !== "Asia" &&
                ele.name !== "Asia-Pacific" &&
                ele.name !== "Middle East" &&
                ele.name !== "Dubai" &&
                ele.name !== "Sharjah" &&
                ele.name !== "Millennium Bostonian"
            );
        });
        if (
            this.props.packageObj.status === "trialing" ||
            this.props.packageObj.subscription?.status === "trialing" ||
            this.props.worldwide_enabled === 0
            // [10201, 11885, 11883, 11379, 10869, 10747].includes(this.props.companyLiteId)
        ) {
            countryOptions = countries.filter((ele) => {
                return ele.name !== "Worldwide";
            });
        }
        let filteredCountryOptions = countryOptions.map((x) => {
            if (
                x.name == "Curacao" ||
                x.name == "Bonaire, Sint Eustatius and Saba" ||
                x.name == "Guernsey" ||
                x.name == "Isle of Man" ||
                x.name == "Millennium Bostonian" ||
                x.name == "Jersey" ||
                x.name == "Saint Martin" ||
                x.name == "Sint Maarten" ||
                x.name == "Worldwide" ||
                x.name == "South Sudan" ||
                x.name == "Saint Barthelemy" ||
                x.name == "Unknown"
            ) {
                return {
                    value: x.id,
                    label: x.name,
                    flag: x.short_name == null ? "" : x.short_name.toLowerCase(),
                    flag_miss: "yes",
                    short_name: x.short_name,
                    gnip_filters: x.gnip_filters,
                };
            } else {
                return {
                    value: x.id,
                    label: x.name,
                    flag: x.short_name == null ? "" : x.short_name.toLowerCase(),
                    flag_miss: "no",
                    short_name: x.short_name,
                    gnip_filters: x.gnip_filters,
                };
            }
        });
        // return filteredCountryOptions;

        // filteredCountryOptions.forEach((x) => {
        //     x.gnip_filters == null && console.log(x.label, x.gnip_filters);
        // });

        let countriesWithgnip = filteredCountryOptions.filter((obj) => {
            if (obj.label === "Worldwide") return obj;
            else return obj.gnip_filters !== null;
        });

        return countriesWithgnip;
    };
    render() {
        let boolVal = this.props.packageObj.package_code === "free";
        return (
            <div className={`countrydropdown ${this.props.popupModal && "location__popup__modal"}`}>
                <div className={`location__field  ${boolVal && "disable__location"}`}>
                    {/* <span>Which location do you wnated to track ?</span> */}
                    <Select
                        className="country-list skiptranslate"
                        classNamePrefix="select"
                        value={this.props.selectedCountryOptions}
                        isSearchable
                        isMulti
                        placeholder="Select Location"
                        options={this.getCountryList()}
                        onChange={this.props.handleCountryChange}
                        formatOptionLabel={this.formatOptionLabel}
                        maxMenuHeight={150}
                        styles={this.customStyle}
                        components={{ IndicatorSeparator: () => null }}
                        closeMenuOnSelect={false}
                        isDisabled={boolVal}
                        ref={this.props.innerRef}

                        // menuIsOpen={this.props.menuIsOpen}
                    />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        allLocations: state.filterSettingReducer.masterLocations,
        packageObj: state.globalReducer.packageObj,
        companyLiteId: state.globalReducer.company.company_lite_company_id,
        worldwide_enabled: state.globalReducer.company.worldwide_enabled,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(CountryDropDown);
